import { ReactNode } from "react";

type textBlockProps = {
  title: ReactNode;
  description: ReactNode;
  hint?: ReactNode;
};

export const TextBlock = ({ title, description, hint }: textBlockProps) => (
  <div className="flex flex-col gap-8 md:flex-row md:items-center">
    <div className="w-[228px] h-3 bg-yellow md:min-w-[12px] md:max-w-[12px] md:h-[228px]"></div>
    <div className="flex flex-col gap-3">
      <h2 className="text-2xl lg:text-3xl">{title}</h2>
      <p className="text-base lg:text-lg">{description}</p>
      {hint && (
        <p className="py-2.5 px-9 text-base text-white bg-cornflower-blue rounded-lg lg:text-lg">
          {hint}
        </p>
      )}
    </div>
  </div>
);
